<div class="flex-fill d-flex flex-column content-block dx-card p-3">
  @if (true) {
    <div class="content-block dx-card responsive-paddings" autofocus>
      <dx-form [formData]="filter" [colCount]="3" (onEditorEnterKey)="search()" appAutofocusForm="companyName">
        <dxi-form-item itemType="group" [colSpan]="2" [colCount]="4">
          <dxi-form-item dataField="companyName"></dxi-form-item>
          <dxi-form-item dataField="firstName"></dxi-form-item>
          <dxi-form-item dataField="lastName"></dxi-form-item>
          <dxi-form-item dataField="billCity" [label]="{ text: 'City' }"></dxi-form-item>
        </dxi-form-item>
        <dxi-form-item [colSpan]="3">
          <div *dxTemplate class="btn-toolbar justify-content-end align-items-center">
            @if (customers) {
              <div class="me-3">
                {{ customers.length }} {{ customers.length === 1 ? 'item found' : 'items found' }}
              </div>
            }
            <button type="button" accesskey="s" (click)="search()" class="btn btn-primary me-1">Search</button>
            <button type="button" (click)="clear()" class="btn btn-light">Clear</button>
          </div>
        </dxi-form-item>
      </dx-form>
    </div>
  }
  <div class="flex-fill d-flex flex-column content-block dx-card p-3">
    <div class="d-flex flex-fill flex-column">
      <dx-data-grid
        #dataGrid
        keyExpr="id"
        class="flex-fill d-flex flex-column"
        height="100px"
        [dataSource]="customers"
        [showBorders]="true"
        (onToolbarPreparing)="onToolbarPreparing($event)"
        (onRowDblClick)="rowDoubleClick($event)"
        >
        <dxi-data-grid-column dataField="type.name" caption="Type" width="100"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="companyName" caption="Company Name" width="175" cellTemplate="linkTemplate"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="displayName" caption="Customer Name" width="175" cellTemplate="linkTemplate"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="contactName" caption="Contact Name" width="175" cellTemplate="linkTemplate"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="billingType" width="100"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="phone" width="125"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="email" width="175"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="billAddress1" caption="Address 1" width="175"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="billAddress2" caption="Address 2" width="125"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="billCity" caption="City" width="125"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="billState" caption="State" width="100"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="billZip" caption="Zip" width="75"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="billCountry" caption="Country" width="125"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="salesPerson.name" caption="Sales Person" width="125"></dxi-data-grid-column>
        <dxi-data-grid-column></dxi-data-grid-column>

        <div *dxTemplate="let cell of 'linkTemplate'">
          @if (cell.data) {
            <a [routerLink]="[]" (click)="open(cell.data)">{{ cell.text }}</a>
          }
        </div>

        <dxo-data-grid-selection mode="multiple"></dxo-data-grid-selection>
        <dxo-data-grid-search-panel [visible]="true"></dxo-data-grid-search-panel>
        <dxo-data-grid-filter-row [visible]="true"></dxo-data-grid-filter-row>
        <dxo-data-grid-export [enabled]="true" [allowExportSelectedData]="true"></dxo-data-grid-export>
        <dxo-data-grid-state-storing [enabled]="true" type="localStorage" storageKey="customer-search-grid"></dxo-data-grid-state-storing>
        <div *dxTemplate="let data of 'toolbarButtons'">
          <button
            class="btn btn-primary me-1 mb-2"
            (click)="open(dataGrid.instance.getSelectedRowsData()[0])"
            [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1"
            [hidden]="!isCustomerAdmin"
            >
            Open
          </button>
          <button class="btn btn-success me-2 mb-2" (click)="open()" [hidden]="!isCustomerAdmin">Add</button>
          <button
            class="btn btn-danger me-1 mb-2"
            (click)="delete(dataGrid.instance.getSelectedRowsData()[0])"
            [disabled]="dataGrid.instance.getSelectedRowsData().length === 0"
            [hidden]="!isCustomerAdmin"
            >
            Delete
          </button>
        </div>
        <div *dxTemplate="let data of 'toolbarText'">
          @if (customers) {
            <span class="me-3">
              <strong>
                {{ dataGrid.instance.totalCount() + ' items' }}
                {{
                dataGrid.instance.getSelectedRowsData().length > 0
                ? dataGrid.instance.getSelectedRowsData().length + ' selected'
                : ''
                }}
              </strong>
            </span>
          }
        </div>
      </dx-data-grid>
    </div>
  </div>
</div>
